import { CommandResult } from '../amorg-common'
import { ActionPointView } from '../amorg-common'
import { UserTarget } from '../amorg-common'
import { apiPath } from "./../amorg-common";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

export const createActionPoint = async (
    actionPointId: string,
    actionPlanTopicId: string,
    description: string,
    assignedUser: UserTarget | null,
    deadline: Date | null
): Promise<CommandResult> =>
    commandAuthWrapper(`${apiPath}/actionpoints`, 'POST',
        { actionPointId, actionPlanTopicId, description, assignedUser, deadline });

export const updateActionPoint = async (
    actionPointId: string,
    description: string,
    assignedUser: UserTarget | null,
    deadline: Date | null,
    done: boolean,
): Promise<CommandResult> =>
    commandAuthWrapper(`${apiPath}/actionpoints/${actionPointId}`, 'PUT',
        { description, assignedUser, deadline, done });

export const deleteActionPoint = async (
    actionPointId: string
): Promise<CommandResult> =>
    commandAuthWrapper(`${apiPath}/actionpoints/${actionPointId}`, 'DELETE');

export const getActionPoints = async (
    actionPlanTopicId: string,
): Promise<ActionPointView[]> =>
    queryAuthWrapper(`${apiPath}/actionpoints/${actionPlanTopicId}`);